import React, { useState } from "react";
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginTop: "-10px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "95%",
    marginBottom: "10px",
  },
  select: {
    padding: "6px 10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  chartContainer: {
    width: "100%",
    height: "400px",
    marginBottom: "20px",
  },
  tableContainer: {
    width: "100%",
    maxHeight: "70vh",
    overflowY: "auto",
    border: "1px solid #ccc",
    borderRadius: "6px",
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
    fontSize: "13px",
    minWidth: "1200px",
  },
  th: {
	borderCollapse: "collapse",
    position: "sticky",
    top: 0,
    backgroundColor: "#b7e1b0",
    zIndex: 5,
    padding: "8px",
  },
  td: {
	borderCollapse: "collapse",
    padding: "6px",
  },
};

const BiodiversityFlora = () => {
  const [selectedArea, setSelectedArea] = useState("bedegung");

  const datasets = {
    bedegung: {
      title: "Kawasan Air Terjun Bedegung",
      chartData: [
        { year: 2021, vegetasi: 30, indeks: 3.269 },
        { year: 2022, vegetasi: 30, indeks: 3.294 },
        { year: 2023, vegetasi: 30, indeks: 3.295 },
        { year: 2024, vegetasi: 34, indeks: 3.297 },
        { year: 2025, vegetasi: 58, indeks: 3.373 },
      ],
      tableData: [
        ["1", "Angsana", "Fabaceae", "Pterocarpus indicus", "Endangered", "Appendix II", "Tidak dilindungi", 2, 3, 3, 12, 6],
            ["2", "Asam Jawa", "Fabaceae", "Tamarindus indica L.", "Least Concern", "Non Appendix", "Tidak dilindungi", 3, 5, 5, 5, 2],
            ["3", "Awar-awar", "Moraceae", "Ficus septica", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 2],
            ["4", "Bangkal", "Rubiaceae", "Neonauclea sp", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
            ["5", "Bayur", "Malvaceae", "Pterospermum javanicum", "Least Concern", "Non Appendix", "Tidak dilindungi", 4, 4, 4, 11, 6],
            ["6", "Beunying", "Moraceae", "Ficus fistulosa", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 10],
            ["7", "Bintaro", "Apocynaceae", "Cerbera manghas", "Least Concern", "Non Appendix", "Tidak dilindungi", 3, 3, 3, 3, 3],
            ["8", "Biola cantik", "Moraceae", "Ficus lyrata", "Least Concern", "Non Appendix", "Tidak dilindungi", 5, 5, 5, 3, 2],
            ["9", "Bungur", "Lythraceae", "Lagerstroemia speciosa", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 9, 8, 7, 20, 5],
            ["10", "Cumpleng", "Araceae", "Amorphophallus variabilis", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
            ["11", "Durian", "Malvaceae", "Durio zibethinus", "Data deficient", "Non Appendix", "Tidak dilindungi", 7, 7, 7, 7, 3],
            ["12", "Eboni", "Ebenaceae", "Diospyros celebica", "Vulnerable", "Non Appendix", "Tidak dilindungi", 2, 2, 2, 2, 3],
            ["13", "Ekaliptus Degupta", "Myrtaceae", "Eucalyptus deglupta", "Vulnerable", "Non Appendix", "Tidak dilindungi", 4, 4, 4, 11, 4],
            ["14", "Gaharu", "Thymelaeaceae", "Aquilaria malaccensis", "Critically Endangered", "Appendix II", "Tidak dilindungi", 5, 10, 10, 10, 5],
            ["15", "Genitri", "Elaocarpaceae", "Elaocarpus sphaericus", "Least Concern", "Non Appendix", "Tidak dilindungi", 5, 5, 5, 5, 9],
            ["16", "Girang", "Leeaceae", "Leea indica", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 4],
            ["17", "Halaban", "Lamiaceae", "Vitex pinnata", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 2],
            ["18", "Jabon", "Rubiaceae", "Neolamarckia cadamba", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
            ["19", "Jakaranda", "Bignoniaceae", "Jacaranda mimosifolia", "Vulnerable", "Non Appendix", "Tidak dilindungi", 2, 2, 2, 2, 2],
            ["20", "Jamblang", "Myrtaceae", "Syzygium cumminii", "Least Concern", "Non Appendix", "Tidak dilindungi", 3, 3, 3, 3, 5],
            ["21", "Jambu hutan", "Myrtaceae", "Syzygium sp", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 3],
            ["22", "Jati", "Lamiaceae", "Tectona grandis", "Endangered", "Non Appendix", "Tidak dilindungi", 3, 3, 3, 5, 1],
            ["23", "Kareumbi", "Euphorbiaceae", "Homalanthus populneus", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 2],
            ["24", "Kecapi", "Meliaceae", "Sandoricum koetjape", "Least Concern", "Non Appendix", "Tidak dilindungi", 5, 5, 5, 5, 5],
            ["25", "Keladi", "Araceae", "Alocasia sp", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 2],
            ["26", "Kenari", "Burseraceae", "Canarium commune Linn.", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", 4, 1],
            ["27", "Kepuh", "Malvaceae", "Sterculia foetida", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 5, 5, 5, 5, 1],
            ["28", "Ketapang", "Combretaceae", "Terminalia gigantea", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", 2, 1],
            ["29", "Kopi robusta", "Rubiaceae", "Coffea canephora", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 22],
            ["30", "Kunto bimo", "Bignoniaceae", "Kigelia africana", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
            ["31", "Lobi-lobi", "Salicaceae", "Flacourtia inermis", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 6, 5, 5, 5, 1],
            ["32", "Luwingan", "Moraceae", "Ficus hispida", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 3],
            ["33", "Mahang damar", "Euphorbiaceae", "Macaranga triloba", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 27],
            ["34", "Mangga", "Anacardiaceae", "Mangifera indica", "Data deficient", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
            ["35", "Matoa", "Sapindaceae", "Pometia pinnata", "Least Concern", "Non Appendix", "Tidak dilindungi", 13, 10, 10, 10, 6],
            ["36", "Melinjo", "Gnetaceae", "Gnetum gnemon", "Least Concern", "Non Appendix", "Tidak dilindungi", 4, 4, 4, 4, 2],
            ["37", "Meranti Merah", "Dipterocarpaceae", "Shorea stenopthera", "Endangered", "Non Appendix", "Tidak dilindungi", 5, 5, 5, 5, 1],
            ["38", "Meranti Tembaga", "Dipterocarpaceae", "Shorea leprosula DYER", "Near Threatened", "Non Appendix", "Tidak dilindungi", 8, 8, 8, 8, 1],
            ["39", "Merawan", "Dipterocarpaceae", "Hopea mangarawan Miq", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 7, 7, 7, 10, 3],
            ["40", "Merbau", "Leguminosae", "Instia palembanica Miq", "Near Threatened", "Non Appendix", "Tidak dilindungi", 3, 4, 4, 4, 39],
            ["41", "Mindi", "Meliaceae", "Melia azedarach", "Least Concern", "Non Appendix", "Tidak dilindungi", 5, 5, 5, 5, 1],
            ["42", "Nyamplung", "Calophyllaceae", "Calophyllum inophyllum", "Least Concern", "Non Appendix", "Tidak dilindungi", 12, 12, 12, 12, 4],
            ["43", "Pacing tawar", "Costaceae", "Hellenia speciosa", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
            ["44", "Palem sirip-ikan", "Arecaceae", "Caryota mitis", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 2],
            ["45", "Petai", "Leguminosae", "Parkia speciosa", "Least Concern", "Non Appendix", "Tidak dilindungi", 11, 11, 11, 11, 1],
            ["46", "Poh-pohan", "Anacardiaceae", "Buchanania arborescens", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 7],
            ["47", "Pucuk merah", "Myrtaceae", "Syzygium myrtifolium", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
            ["48", "Pulai", "Apocynaceae", "Alstonia scholaris R.Br.", "Least Concern", "Non Appendix", "Tidak dilindungi", 11, 11, 11, 11, 1],
            ["49", "Resak paya", "Dipterocarpaceae", "Vatica pauciflora", "Vulnerable", "Non Appendix", "Tidak dilindungi", "", "", 5, 1],
            ["50", "Rukam", "Salicaceae", "Flacourtia rukam", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 5, 5, 5, 5, 23],
            ["51", "Senduduk bulu", "Melastomataceae", "Miconia crenata", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
            ["52", "Senggani", "Melastomataceae", "Melastoma malabathricum", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
            ["53", "Simpur", "Rhizophoraceae", "Carallia suffruticosa", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
            ["54", "Suji", "Asparagaceae", "Dracaena angustifolia", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
            ["55", "Tarap", "Moraceae", "Artocarpus elasticus", "Least Concern", "Non Appendix", "Tidak dilindungi", 4, 4, 4, 4, 2],
            ["56", "Tembesu", "Loganiaceae", "Fagraea fragrans Roxb", "Least Concern", "Non Appendix", "Tidak dilindungi", 4, 7, 7, 30, 3],
            ["57", "Wali songo", "Araliaceae", "Schefflera sp", "Vulnerable", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
            ["58", "Wuni", "Phyllanthaceae", "Antidesma bunius", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 3],
      ],
      summary: {
        spesies: [30, 30, 30, 34, 58],
        individu: [165, 172, 171, 247, 254],
        indeks: [3.269, 3.294, 3.295, 3.297, 3.373],
      },
    },
    arboretum: {
      title: "Kawasan Arboretum Pagardewa",
      chartData: [
        { year: 2021, vegetasi: 47, indeks: 2.426 },
        { year: 2022, vegetasi: 48, indeks: 2.478 },
        { year: 2023, vegetasi: 54, indeks: 2.756 },
        { year: 2024, vegetasi: 55, indeks: 2.796 },
        { year: 2025, vegetasi: 96, indeks: 3.794 },
      ],
      tableData: [
        ["1", "Alamanda", "Apocynaceae", "Allamanda cathartica", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 2],
		["2", "Alpukat", "Lauraceae", "Persea americana", "Least Concern", "Non Appendix", "Tidak dilindungi", "", 1, 1, 1, ""],
		["3", "Ancit-Ancit/ Kecrutan", "Bignoniaceae", "Spathodea campanulata", "Endangered", "Non Appendix", "Tidak dilindungi", 4, 4, 4, 4, 24],
		["4", "Angsana kembang", "Fabaceae", "Pterocarpus indicus", "Endangered", "Appendix II", "Tidak dilindungi", 16, 16, 16, 16, 41],
		["5", "Asoka daun-lebar", "Fabaceae", "Ixora sp", "Vulnerable", "Non Appendix", "Tidak dilindungi", "", "", "", "", 3],
		["6", "Asoka daun-lebar", "Rubiaceae", "Ixora sp", "Vulnerable", "Non Appendix", "Tidak dilindungi", "", "", "", "", 5],
		["7", "Belimbing", "Oxalidaceae", "Averrhoa carambola", "Data Deficient", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
		["8", "Beringin alii", "Moraceae", "Ficus maclellandii", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 61],
		["9", "Beringin Gunung", "Moraceae", "Ficus benjamina", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 22, 21, 22, 22, 11],
		["10", "Beringin walik", "Moraceae", "Ficus kurzii", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 23],
		["11", "Bidara", "Rhamnaceae", "Ziziphus mauritiana", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
		["12", "Bintaro", "Apocynaceae", "Cerbera manghas", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 4, 4, 6, 11, 6],
		["13", "Biola cantik", "Moraceae", "Ficus lyrata", "Least Concern", "Non Appendix", "Tidak dilindungi", 7, 7, 7, 7, 7],
		["14", "Bisbul", "Ebenaceae", "Diospyros discolor", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 7, 7, 7, 7, 36],
		["15", "Bisoro", "Moraceae", "Ficus hispida", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
		["16", "Buah nona", "Annonaceae", "Annona reticulata", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
		["17", "Bugenvil", "Nyctaginaceae", "Bougainvillea sp", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 6],
		["18", "Bunga tasbih", "Cannaceae", "Canna indica", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 40],
		["19", "Bungur", "Lythraceae", "Lagerstroemia speciosa", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 2, 2, 7, 10, 36],
		["20", "Cempaka", "Magnoliaceae", "Magnolia champaca", "Vulnerable", "Non Appendix", "Tidak dilindungi", 5, 5, 5, 5, 13],
		["21", "Cempedak", "Moraceae", "Artocarpus integer", "Critically Endangered", "Appendix II", "Tidak dilindungi", 5, 5, 5, 5, 9],
		["22", "Daun Kupu-Kupu", "Fabaceae", "Bauhinia purpurea", "Data Deficient", "Non Appendix", "Tidak dilindungi", 4, 4, 4, 4, 4],
		["23", "Delima", "", "Punica granatum", "Least Concern", "Non Appendix", "Tidak dilindungi", "", 1, 1, 1, ""],
		["24", "Duku", "Meliaceae", "Lansium dosmeticum", "Least Concern", "Non Appendix", "Tidak dilindungi", 1, 1, 1, 1, 7],
		["25", "Durian", "Malvaceae", "Durio zibethinus", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 5, 5, 5, 5, 1],
		["26", "Eboni", "Ebenaceae", "Diospyros celebica", "Least Concern", "Non Appendix", "Tidak dilindungi", 10, 10, 10, 10, 20],
		["27", "Gaharu", "Thymelaeaceae", "Aquilaria malaccensis", "Critically Endangered", "Appendix II", "Tidak dilindungi", 13, 13, 13, 14, 24],
		["28", "Gamal", "Fabaceae", "Gliricidia sepium", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
		["29", "Gandaria", "", "Bouea macrophylla", "Least Concern", "Non Appendix", "Tidak dilindungi", "", 30, 30, 22, ""],
		["30", "Gelam/Kayu Putih", "Myrtaceae", "Melaleuca leucadendron", "Least Concern", "Non Appendix", "Tidak dilindungi", 6, 6, 6, 6, 2],
		["31", "Gempol", "Rubiaceae", "Nauclea orientalis", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 2],
		["32", "Halaban", "Lamiaceae", "Vitex pinnata", "Least Concern", "Non Appendix", "Tidak dilindungi", "", 1, 1, 6, ""],
		["33", "Jabon Merah", "Rubiaceae", "Anthocephalus macrophyllus", "Least Concern", "Non Appendix", "Tidak dilindungi", 8, 8, 6, 6, 2],
		["34", "Jabon Putih", "Rubiaceae", "Anthocephalus cadamba", "Least Concern", "Non Appendix", "Tidak dilindungi", 6, 6, 6, 6, 8],
		["35", "Jamblang (duwet)", "Myrtaceae", "Syzygium cumminii", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 5, 5, 5, 5, 1],
		["36", "Jambu Air", "Myrtaceae", "Syzygium aqueum", "Least Concern", "Non Appendix", "Tidak dilindungi", 4, 4, 6, 9, 7],
		["37", "Jambu Batu", "", "Psidium guajava", "Least Concern", "Non Appendix", "Tidak dilindungi", "", 5, 5, 5, 21],
		["38", "Jambu Bol (Jamaica)", "Myrtaceae", "Syzygium malaccensis", "Vulnerable", "Non Appendix", "Tidak dilindungi", 4, 4, 4, 4, 2],
		["39", "Janitri", "Elaocarpaceae", "Elaocarpus sphaericus K. Schum.", "Least Concern", "Non Appendix", "Tidak dilindungi", 6, 6, 6, 6, 2],
		["40", "Jati", "Lamiaceae", "Tectona grandis", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 3],
		["41", "Jati putih", "Lamiaceae", "Gmelina arborea", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 14],
		["42", "Jengkol", "Fabaceae", "Archidendron pauciflorum", "Vulnerable", "Non Appendix", "Tidak dilindungi", "", "", "", "", 4],
		["43", "Johar", "Fabaceae", "Cassia siamea", "Least Concern", "Non Appendix", "Tidak dilindungi", 4, 4, 4, 5, 4],
		["44", "Karet", "Euphorbiaceae", "Hevea brasiliensis", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 3],
		["45", "Kayu Afrika", "Fagaceae", "Maesopsis eminii", "Data Deficient", "Non Appendix", "Tidak dilindungi", 2, 2, 2, 2, 1],
		["46", "Kayu Manis", "Lauraceae", "Cinnamomum zeylanicum", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 2, 2, 1, 1, 1],
		["47", "Kemang", "Anacardiaceae", "Mangifera kemanga", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 15],
		["48", "Kembang sepatu", "Malvaceae", "Hibiscus rosa-sinensis", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
		["49", "Kenanga", "Annonaceae", "Cananga odorata", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 2],
		["50", "Kepel", "Annonaceae", "Stelechocarpus burahol", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 3],
		["51", "Ketapang Hutan", "Combretaceae", "Terminalia catappa", "Least Concern", "Non Appendix", "Tidak dilindungi", 8, 8, 8, 8, 22],
		["52", "Ketapang Kencana", "Combretaceae", "Terminalia mantaly", "Data Deficient", "Non Appendix", "Tidak dilindungi", 3, 3, 5, 5, 3],
		["53", "Khaya", "Meliaceae", "Khaya anthotheca", "Least Concern", "Non Appendix", "Tidak dilindungi", 4, 4, 6, 6, 6],
		["54", "Kiara payung", "Sapindaceae", "Filicium decipiens", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 9],
		["55", "Kimeng", "Moraceae", "Ficus microcarpa", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", 1, 7, ""],
		["56", "Kunto Bimo", "Bignoniaceae", "Kigelia africana", "Near Threatened", "Non Appendix", "Tidak dilindungi", 7, 7, 7, 9, 9],
		["57", "Lamtoro", "Fabaceae", "Leucaena leucocephala", "Near Threatened", "Non Appendix", "Tidak dilindungi", "", "", "", "", 15],
		["58", "Mahoni Daun Besar", "Meliaceae", "Swietenia macrophylla", "Endangered", "Appendix II", "Tidak dilindungi", 10, 10, 10, 10, 4],
		["59", "Mangga", "Anacardiaceae", "Mangifera indica", "Least Concern", "Non Appendix", "Tidak dilindungi", 6, 6, 11, 17, 37],
		["60", "Manggis", "Guttiferae", "Garcinia cowa", "Least Concern", "Non Appendix", "Tidak dilindungi", 4, 4, 2, 7, 10],
		["61", "Matoa", "Sapindaceae", "Pometia pinnata", "Least Concern", "Non Appendix", "Tidak dilindungi", 7, 7, 7, 2, 22],
		["62", "Mawar", "Rosaceae", "Rosa hybrida", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 3],
		["63", "Menteng", "Phyllanthaceae", "Baccaurea racemosa", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 4, 4, 4, 2, 1],
		["64", "Meranti Balangeran", "Dipterocarpaceae", "Shorea belangeran", "Least Concern", "Non Appendix", "Tidak dilindungi", 4, 4, 1, 1, 17],
		["65", "Meranti Tembaga", "", "Rubroshorea leprosula", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", 30, 30, 1, ""],
		["66", "Merawan (Hopea)", "Dipterocarpaceae", "Hopea mangarawan Miq", "Least Concern", "Non Appendix", "Tidak dilindungi", 2, 2, 4, 5, 4],
		["67", "Merbau", "Fabaceae", "Intsia palembanica", "Least Concern", "Non Appendix", "Tidak dilindungi", 1, 6, 6, 6, 1],
		["68", "Mindi", "Meliaceae", "Melia azederach", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
		["69", "Mondokaki", "Apocynaceae", "Tabernaemontana divaricata", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 10],
		["70", "Nangka", "Moraceae", "Artocarpus heterophyllus", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 10],
		["76", "Pucuk Merah", "Myrtaceae", "Syzygium Oleina", "Least Concern", "Non Appendix", "Tidak dilindungi", 291, 291, 291, 291, 176],
		["77", "Pulai Gadang", "Apocynaceae", "Alstonia scholaris R.Br.", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 3, 3, 4, 6, 10],
	    ["78", "Rambutan", "Sapindaceae", "Nephelium lappaceum", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 3, 3, 3, 3, 3],
	    ["79", "Randu", "Malvaceae", "Ceiba pentandra", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 9],
	    ["80", "Rasamala", "Altingiaceae", "Altingia excelsa Noronha", "Near Threatened", "Non Appendix", "Tidak dilindungi", 3, 3, 3, 3, 1],
	    ["81", "Salak", "Arecaceae", "Salacca zalacca", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
	    ["82", "Salam", "Myrtaceae", "Syzygium polyanthum", "Near Threatened", "Non Appendix", "Tidak dilindungi", 11, 11, 11, 10, 14],
	    ["83", "Salam badak", "Myrtaceae", "Syzygium acuminatissimum", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 8],
	    ["84", "Santos kuning", "Myrtaceae", "Xanthostemon chrysanthus", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
	    ["85", "Sawit", "Arecaceae", "Elaeis guineensis", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 2],
	    ["86", "Seruk", "Theaceae", "Schima wallichii", "Least Concern", "Non Appendix", "Tidak dilindungi", "", 30, 30, 9, ""],
	    ["87", "Simpoh air", "Dilleniaceae", "Dillenia philippinensis", "Near Threatened", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
	    ["88", "Soka", "Rubiaceae", "Ixora coccinea", "Not Evaluated", "Non Appendix", "Tidak dilindungi", "", "", "", "", 62],
	    ["89", "Tabebuia", "Bignoniaceae", "Tabebuia rosea", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 5],
	    ["90", "Tabebuia", "Bignoniaceae", "Tabebuia aurea", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 7],
	    ["91", "Tanjung", "Sapotaceae", "Mimusops elengi", "Least Concern", "Non Appendix", "Tidak dilindungi", 10, 10, 10, 5, 15],
	    ["92", "Tembesu", "Loganiaceae", "Fagraea fragrans Roxb", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 2, 2, 4, 3, 2],
	    ["93", "Trembesi", "Fabaceae", "Samanea saman", "Least Concern", "Non Appendix", "Tidak dilindungi", 3, 3, 3, 4, 2],
	    ["94", "Waru", "Malvaceae", "Hibiscus tilliaceus", "Not Evaluated", "Non Appendix", "Tidak dilindungi", 4, 4, 4, 9, 20],
	    ["95", "Waru gunung", "Malvaceae", "Hibiscus macrophyllus", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 1],
	    ["96", "Wuni", "Phyllanthaceae", "Antidesma bunius", "Least Concern", "Non Appendix", "Tidak dilindungi", "", "", "", "", 15]
      ],
      summary: {
        spesies: [47, 48, 54, 55, 96],
        individu: [557, 566, 675, 692, 1129],
        indeks: [2.426, 2.478, 2.756, 2.796, 3.794],
      },
    },
  };
				

  const selected = datasets[selectedArea];

  return (
    <div style={styles.wrapper} className="content-container">
      {/* 🔹 Header dengan dropdown di kiri */}
      <div style={styles.headerRow}>
        

        <h1 style={{ flex: 1, textAlign: "center", margin: 0 }}>
          Biodiversity Flora {selected.title}
        </h1>

      </div>
	  
	  <div style={{ width: "100%", marginBottom:"5px", display: "flex", justifyContent: "flex-start" }}>
		<select
		  value={selectedArea}
		  onChange={(e) => setSelectedArea(e.target.value)}
		  style={styles.select}
		>
		  <option value="bedegung">Kawasan Air Terjun Bedegung</option>
		  <option value="arboretum">Kawasan Arboretum Pagardewa</option>
		</select>
	  </div>
      {/* 🔹 TABEL */}
      <div style={styles.tableContainer}>
        <table border="1" className="table table-bordered" style={styles.table}>
          <thead>
            <tr>
              {[
                "No",
                "Nama Jenis",
                "Family",
                "Genus & Species",
                "Red List IUCN",
                "Appendix CITES",
                "PerMen LHK Nomor 106/2018",
                "2021",
                "2022",
                "2023",
                "2024",
                "2025",
              ].map((header, i) => (
                <th key={i} style={styles.th}>
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {selected.tableData.map((row, index) => (
              <tr key={index}>
                {row.map((cell, i) => (
                  <td key={i} style={styles.td}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}

            {/* Ringkasan */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="7">Jumlah Spesies</td>
              {selected.summary.spesies.map((v, i) => (
                <td key={i}>{v}</td>
              ))}
            </tr>
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="7">Individu (Batang)</td>
              {selected.summary.individu.map((v, i) => (
                <td key={i}>{v}</td>
              ))}
            </tr>
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="7">Indeks (H')</td>
              {selected.summary.indeks.map((v, i) => (
                <td key={i}>{v}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      {/* 🔹 GRAFIK */}
      <div style={styles.chartContainer}>
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart
            data={selected.chartData}
            margin={{ top: 20, right: 40, left: 10, bottom: 20 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
            <XAxis dataKey="year" />

            <YAxis
              yAxisId="left"
              orientation="left"
              label={{
                value: "Indeks Kehati (H')",
                angle: -90,
                position: "insideLeft",
                offset: 10,
              }}
              domain={[
                (dataMin) => Math.floor((dataMin - 0.5) * 10) / 10,
                (dataMax) => Math.ceil((dataMax + 0.1) * 10) / 10,
              ]}
              tickFormatter={(val) => val.toFixed(1)}
            />

            <YAxis
              yAxisId="right"
              orientation="right"
              label={{
                value: "Jumlah Vegetasi Pohon",
                angle: -90,
                position: "insideRight",
                offset: 10,
              }}
            />

            <Tooltip />
            <Legend verticalAlign="top" height={36} />
            <Bar
              yAxisId="right"
              dataKey="vegetasi"
              name="Jumlah Vegetasi Pohon"
              fill="#82b6f7"
              barSize={40}
              radius={[4, 4, 0, 0]}
            />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="indeks"
              name="Indeks Kehati (H')"
              stroke="#333"
              strokeWidth={2}
              dot={{ fill: "#333", r: 4 }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BiodiversityFlora;
